module.exports = __webpack_public_path__ + "static/media/sachin.f98f08dd.png";